<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-map-marker-alt'"
          [title]="'Site'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="dataConfig.form.get(['site'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'site'}"
          (save)="save(['SiteEditComponent', 'site'])"
          (undo)="undo(['site'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>

    </ul>
  </form>
</ng-template>

<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex: 1 1 0px">site dirty: {{dataConfig?.groupConfigs?.groupConfigs[1]?.config[2]?.presentation|json}}</pre>
  <pre style="flex: 1 1 0px">isStatusOff$: {{(isStatusOff$|async)}}</pre>
  <pre style="flex: 1 1 0px">status presentation: {{dataConfig.groupConfigs.groupConfigs[1].config[2].presentation|json}}</pre>
  <!--  <pre style="flex: 1 1 0px">site dirty: {{dataConfig.form.get(['site']).dirty}}</pre>-->
  <!--  <pre style="flex: 1 1 0px">subscription dirty: {{dataConfig.form.get(['subscription']).dirty}}</pre>-->
  <!--  <pre style="flex: 1 1 0px">serverForm dirty: {{dataConfig.form.get(['serverForm']).dirty}}</pre>-->
  <!--  <pre style="flex: 1 1 0px">videoOption dirty: {{dataConfig.form.get(['videoOption']).dirty}}</pre>-->
</div>

